import debounce from 'lodash/debounce'
const SELECTOR = '.js-blog-search'
const LIST_CLASS = 'blog-search-list'
const URL = 'index.php?route=blog/category/search'

function initBlogSearch(input, {onSelect, onInput} = {}) {
  const list = createList()
  let index = -1

  const fetchFunction = makeFetchFunction()

  function createList() {
    const list = document.createElement('div')
    list.classList.add(LIST_CLASS)
    list.hidden = true
    return list
  }

  function showList() {
    list.hidden = false
  }

  function hideList() {
    index = -1
    list.hidden = true
  }

  function fillList(articles) {
    list.innerHTML = ''

    if (articles.length === 0) return

    const buttons = articles.map(article => {
      const button = document.createElement('button')
      button.article = article
      button.textContent = article.name
      return button
    })

    list.append(...buttons)
  }

  function writeError(message) {
    list.innerHTML = ''
    const element = document.createElement('div')
    element.textContent = message
    list.appendChild(element)
  }

  async function handleInput() {
    index = -1
    const query = input.value
    onInput && onInput(query)
    if (query.length > 2) {
      const response = await fetchFunction(query)
      if (response.articles?.length > 0) {
        fillList(response.articles)
      } else {
        writeError('Ничего не найдено')
      }
    }
  }

  function select(article) {
    input.value = article.name // Create a new input event
    const event = new Event('input', {
      bubbles: true, // The event bubbles up through the DOM
      cancelable: true // The event can be canceled
    })
    input.dispatchEvent(event)
    input.article = article
    onSelect && onSelect(article)
  }

  function getIndex(index, key, listLength){
    if(key === 'ArrowDown'){
      return (index + 1) % listLength
    } else if(key === 'ArrowUp'){
      return index - 1 < 0 ? listLength - 1 : index - 1
    }
  }

  function handleKeyboard(event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      const listLength = list.children.length
      const prevIndex = index
      const nextIndex = getIndex(index, event.key, listLength)
      if (prevIndex !== -1 && list.children[prevIndex]) {
        list.children[prevIndex].classList.remove('active')
      }
      if (list.children[nextIndex]) {
        list.children[nextIndex].classList.add('active')
      }
      index = nextIndex
    }
    if(event.key === 'Enter' && index !== -1 && list.children[index]){
      select(list.children[index].article)
    }
  }

  list.addEventListener('mousedown', (event) => {
    if (event.target.tagName === 'BUTTON') {
      event.preventDefault()
      select(event.target.article)
    }
  })

  input.addEventListener('keydown', handleKeyboard)

  input.insertAdjacentElement('afterend', list)

  input.addEventListener('focus', () => {
    showList()
    handleInput()
  })
  input.addEventListener('input', debounce(handleInput, 300))
  input.addEventListener('blur', hideList)
}

async function fetchBlogSearch(query) {

  try {
    const response = await fetch(URL, {
      method: 'POST',
      body: JSON.stringify({'search': query}),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const dataJson = await response.json()

    if (Object.keys(dataJson).length === 0) {
      console.warn('Empty response received from server')
      return null
    }

    return dataJson
  } catch (error) {
    console.error('Error fetching:', error)
  }
}

function makeFetchFunction(){
  let lastAbort = null
  return async function(query){
    if(lastAbort){
      lastAbort.abort()
    }
    const controller = new AbortController()
    lastAbort = controller
    return fetchBlogSearch(query, {signal: controller.signal})
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(SELECTOR).forEach((input) => initBlogSearch(input))
})